import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "@dreamchimney/react-axios";

import { LOCAL_STORE_JWT } from "~/utils/main";

import useFormHandler from "../useFormHandler";
import { validateNonAuth, validateAuth } from "./CommentFormValidate";
import { useUser } from "~/Context/userContext";

import { postComment } from "~/api/postComment";

import "./CommentForm.less";

const CommentForm = ({ postId, post, children }) => {
  const { state: userState, dispatch } = useUser();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const initialFormValues = {
    otd_new: "",
    otd_comment: "",
  };

  const openSignin = () => {
    if (!userState.loggedin) {
      dispatch({ type: "signin_open" });
      return;
    }
  };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const formSubmit = async () => {
    setSaving(true);
    try {
      const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;

      const payload = {
        id: postId,
        jwt,
        ...inputs,
      };

      const result = await postComment(axios, payload);

      // highlight the comment with css shadow
      result.data.comment.new = true;

      // put the comment back into post
      // post.comments.push(result.data.comment);
      post.comments.unshift(result.data.comment);

      // clear form fields
      inputs.otd_comment = ``;
      inputs.otd_new = ``;

      setSaving(false);
      setSaved(true);
    } catch (err) {
      console.log("FAIL err:", err);
      setSaving(false);
    }
  };

  const validate = !loading && userState.loggedin ? validateAuth : validateNonAuth;

  const { inputs, handleInputChange, handleSubmit, insertLinkTag, insertImageTag, errors } = useFormHandler(
    initialFormValues,
    formSubmit,
    validate
  );
  if (loading || !userState) {
    return <div>Loading...</div>;
  }
  return (
    <div className="comment-form-padding">
      <div className="comment-form-wrapper">
        <Form className="otd-form comment-add-form" noValidate onSubmit={(e) => handleSubmit(e)}>
          <Row noGutters>
            <Col md={6}>
              <div>
                {userState.loggedin && userState.user && (
                  <div style={{ marginBottom: "12px" }}>
                    Your Name:{" "}
                    <strong>
                      {userState.user.full_name}
                      {userState.isChim ? ` Chimney` : null}
                    </strong>
                  </div>
                )}
                {!userState.loggedin && (
                  <Form.Group controlId="otd_guest" className={errors.otd_guest ? "error" : ""}>
                    <Form.Label>Your Name:</Form.Label>
                    <Form.Control
                      disabled={loading}
                      name="otd_guest"
                      onChange={handleInputChange}
                      value={inputs.otd_guest || ""}
                      type="text"
                      autoComplete="off"
                      placeholder=""
                      style={{ width: "50%" }}
                    />
                    <span style={{ display: "inline-block", marginTop: "12px", marginBottom: "8px", fontSize: "12px" }}>
                      or{" "}
                      <span className="signin-link-wrapper" onClick={openSignin}>
                        Login / Register
                      </span>
                    </span>
                    {errors.otd_guest && <div className="help error">{errors.otd_guest}</div>}
                  </Form.Group>
                )}
              </div>

              <div>
                <Form.Group controlId="otd_comment" className={errors.otd_comment ? "error" : ""}>
                  <Form.Label>Add your comment below:</Form.Label>
                  <Form.Control
                    disabled={loading || saving}
                    name="otd_comment"
                    onChange={handleInputChange}
                    value={inputs.otd_comment || ""}
                    as="textarea"
                    rows={inputs.otd_comment.length > 300 ? 8 : 3}
                  />
                  {errors.otd_comment && <span className="help error">{errors.otd_comment}</span>}
                </Form.Group>
              </div>
              <div className="comment-html-help">
                <div>
                  HTML Help:{" "}
                  <a href="javascript:;" onClick={() => insertLinkTag()}>
                    Add link
                  </a>
                  &nbsp;&nbsp;
                  <a href="javascript:;" onClick={() => insertImageTag()}>
                    Add Image
                  </a>
                </div>
              </div>
            </Col>
            <Col md={{ span: 5, offset: 1 }}>
              <div className="add-another-otd">
                <div>Add an alternate “_____” of the Day to this:</div>
                <div>
                  “
                  <Form.Control
                    name="otd_new"
                    disabled={loading || saving}
                    onChange={handleInputChange}
                    value={inputs.otd_new || ""}
                    type="text"
                    autoComplete="off"
                    maxLength="40"
                    className="newOtdTextField"
                  />
                  ”&nbsp;&nbsp;of the Day
                </div>
              </div>
            </Col>
          </Row>

          <Row noGutters>
            <Col>
              <div className="buttons">
                <Button disabled={loading || saving} size="sm" variant="light outline-dark" onClick={() => handleSubmit()}>
                  {saving ? `Saving...` : `Add Comment`}
                </Button>
              </div>
              {saved && (
                <div style={{ margin: "20px 0 0 0", color: "#333" }}>
                  <strong>Success! Your comment was added below.</strong>
                </div>
              )}
            </Col>
          </Row>
        </Form>
      </div>
      {React.cloneElement(children, { item: post })}
    </div>
  );
};

CommentForm.propTypes = {
  postId: PropTypes.string,
};

CommentForm.defaultProps = {
  // postId: '',
};

export default CommentForm;
